import { render, staticRenderFns } from "./LogisticServices.vue?vue&type=template&id=2d5fa286&"
import script from "./LogisticServices.vue?vue&type=script&lang=js&"
export * from "./LogisticServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports